
import { processedUrl } from '@padlet/vivaldi-client'
import { Component, namespace, Prop, Vue } from 'bits/vue'
import { SearchFilters } from 'bits/web_search'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'

@Component({ components: { OzContainedButton } })
export default class AiImageSearchSample extends Vue {
  /**
   * Whether dark mode is active or not
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  @namespace('contentPicker').Action setSearchQuery!: (payload: { query: string }) => void
  @namespace('contentPicker').Action search!: (payload?: { query: string }) => void
  @namespace('contentPicker').Action pickSearchFilter!: (payload: { filter: SearchFilters }) => void

  processedUrl = processedUrl
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset

  AI_SEARCH_SAMPLE =
    'An expressive oil painting of a basketball player dunking, as depicted as an explosion of a nebula'

  searchForSample(): void {
    this.setSearchQuery({ query: this.AI_SEARCH_SAMPLE })
    this.pickSearchFilter({ filter: SearchFilters.AiImages })
    this.search()
  }
}
